export default {
  cancelButton: {
    id: 'profile_page_legal_details_tab_modal_cancel_button',
    defaultMessage: 'Cancel',
  },
  companyIdentificationNumberInputLabel: {
    id: 'profile_page_legal_details_tab_edit_company_identification_number_input_label',
    defaultMessage: 'Company identification number',
  },
  invalidLength: {
    id: 'profile_page_legal_details_tab_edit_invalid_length',
    defaultMessage: 'This field is too long',
  },
  labelDisabledInput: {
    id: 'profile_page_legal_details_tab_edit_disabled_input_label',
    defaultMessage: 'Need to update this info? Contact your SSM.',
  },
  legalBusinessNameInputLabel: {
    id: 'profile_page_legal_details_tab_edit_legal_details_name_input_label',
    defaultMessage: 'Legal business name',
  },
  kanjiLegalCompanyName: {
    id: 'profile_page_legal_details_tab_edit_legal_details_name_kanji_input_label',
    defaultMessage: 'Legal business name (Kanji)',
  },
  kanaLegalCompanyName: {
    id: 'profile_page_legal_details_tab_edit_legal_details_name_kana_input_label',
    defaultMessage: 'Legal business name (Kana)',
  },
  latinLegalCompanyName: {
    id: 'profile_page_legal_details_tab_edit_legal_details_name_latin_input_label',
    defaultMessage: 'Legal business name (Latin)',
  },
  organizationType: {
    id: 'profile_page_legal_details_tab_edit_legal_details_organization_type_label',
    defaultMessage: 'Organization type',
  },
  invalidAustraliaIdentificationNumber: {
    id: 'profile_page_legal_details_tab_edit_legal_details_australia_identification_number_format_error',
    defaultMessage: 'The identification number should be 9 digits long',
  },
  invalidJapanIdentificationNumber: {
    id: 'profile_page_legal_details_tab_edit_legal_details_japan_identification_number_format_error',
    defaultMessage:
      'The identification number should be in this format: XXXX-XX-XXXXXX',
  },
  invalidJapanSecondhandNumber: {
    id: 'profile_page_legal_details_tab_edit_legal_details_japan_secondhand_number_format_error',
    defaultMessage:
      'The secondhand number should be in this format: XXXXXXXXXXXX',
  },
  secondhandDealerNumber: {
    id: 'profile_page_legal_details_tab_edit_legal_details_secondhand_number_label',
    defaultMessage: 'Secondhand number',
  },
  secondhandDealerNumberIssuingPrefecture: {
    id: 'profile_page_legal_details_tab_edit_legal_details_secondhand_number_issuing_prefecture_label',
    defaultMessage: 'Secondhand number issuing prefecture',
  },
  legalDetailsUpdatedToastSuccessContent: {
    id: 'profile_page_legal_details_tab_success_toast_content',
    defaultMessage: 'You’re that much closer to selling on Back Market.',
  },
  legalDetailsUpdatedToastSuccessTitle: {
    id: 'profile_page_legal_details_tab_success_toast_title',
    defaultMessage: 'Details updated ✔️',
  },
  modalInfoBlockContent: {
    id: 'profile_page_legal_details_tab_modal_info_block_content',
    defaultMessage: 'This information will be visible to your customers.',
  },
  modalInfoBlockTitle: {
    id: 'profile_page_legal_details_tab_modal_info_block_title',
    defaultMessage: 'Just so you know',
  },
  modalTitle: {
    id: 'profile_page_legal_details_tab_modal_title',
    defaultMessage: 'Legal details',
  },
  required: {
    id: 'profile_page_legal_details_tab_edit_required',
    defaultMessage: 'This field is required',
  },
  submitButton: {
    id: 'profile_page_legal_details_tab_modal_submit_button',
    defaultMessage: 'Add details',
  },
  updatingText: {
    id: 'profile_page_legal_details_tab_updating',
    defaultMessage: 'Updating your legal details...',
  },
  errorTitle: {
    id: 'profile_page_legal_details_tab_error_title',
    defaultMessage: 'Oops...',
  },
}
